/* eslint-disable no-await-in-loop */
import { AppThunk } from '@lib/state/types';
import {
    FetchTiktokLinkPayload,
    FetchPostsPayload,
} from '@lib/domain/tiktok/interface';
import { TiktokActions } from '@lib/state/_actions';

/**
 * get tiktok link
 *
 * @returns {AppThunk<Promise<void>>}
 */
export const fetchTiktokLink =
    (payload: FetchTiktokLinkPayload): AppThunk<Promise<void>> =>
    async (dispatch, _getState, container): Promise<void> => {
        const response = await container.cradle.tiktokRepository.getUserInfo(
            payload,
        );
        const { user_info } = response;
        let isValid = false;
        if (user_info && user_info.nickname && user_info.avatarThumb) {
            if (user_info.is_private) {
                throw new Error(
                    'Your Tiktok profile is private. Only public profiles can be boosted',
                );
            }
            isValid = true;
            dispatch(TiktokActions.setTiktokUser(user_info));
        }
        if (!isValid) {
            throw new Error('This TikTok username does not exist. Try again');
        }
    };

/**
 * get tiktok post
 *
 * @returns {AppThunk<Promise<void>>}
 */

export const fetchPosts =
    (payload: FetchPostsPayload): AppThunk<Promise<void>> =>
    async (dispatch, _getState, container): Promise<void> => {
        const result = await container.cradle.tiktokRepository.getPosts(
            payload,
        );
        const { posts, has_more, cursor } = result;
        if (!has_more) {
            dispatch(TiktokActions.setTiktokCursorPost(undefined));
        }
        if (has_more && cursor) {
            dispatch(TiktokActions.setTiktokCursorPost(cursor));
        }
        dispatch(TiktokActions.setTiktokPosts(posts || []));
    };

const TiktokThunks = {
    fetchTiktokLink,
    fetchPosts,
};

export default TiktokThunks;
